import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DialogModule, DialogService, LoginModule, ModalModule, ToastModule } from '@inera/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NotificationService } from './service';
import { LoggedoutComponent } from './components/loggedout/loggedout.component';
import { ErrorViewComponent } from './components/error-view/error-view.component';
import { AdminSithsEidModule } from './modules/admin-idp-data-aggregation/admin-siths-eid.module';

@NgModule({
  declarations: [AppComponent, LoggedoutComponent, ErrorViewComponent],
  bootstrap: [AppComponent],
  imports: [BrowserModule, AppRoutingModule, AdminSithsEidModule, LoginModule, ModalModule, DialogModule, ToastModule],
  providers: [DialogService, NotificationService, provideHttpClient(withInterceptorsFromDi())]
})
export class AppModule {}
